<!-- param: viewMode-控制显示，id-控制数据加载，mode-控制button加载 -->
<template>
  <el-container
    v-loading="loading"
  >
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <el-button class="ik-list-menu-btn" size="medium" @click="listDetailsBtn">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="openPrint">打印</el-button>
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
          <el-button v-if="mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoDetailsBtn">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <!-- 表头 -->
        <el-form
          v-if="viewMode == 'info'"
          id="ik-info-head"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
          @validate="validate"
        >
          <el-row>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_id'"
                v-model="data.head['id']"
                code="id"
                name="ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="12">
              <ik-form-text
                :ref="'input_code'"
                v-model="data.head['code']"
                code="code"
                name="编号"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_storeId'"
                v-model="data.head['storeId']"
                code="storeId"
                name="门店ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_positionId'"
                v-model="data.head['positionId']"
                code="positionId"
                name="药库ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_positionCode'"
                v-model="data.head['positionCode']"
                code="positionCode"
                name="药库编号"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_positionName'"
                v-model="data.head['positionName']"
                code="positionName"
                name="药库名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_materielId'"
                v-model="data.head['materielId']"
                code="materielId"
                name="药品ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielCode'"
                v-model="data.head['materielCode']"
                code="materielCode"
                name="药品编号"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielName'"
                v-model="data.head['materielName']"
                code="materielName"
                name="药品名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_medSpecId'"
                v-model="data.head['medSpecId']"
                code="medSpecId"
                name="供应商家ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_medSpecCode'"
                v-model="data.head['medSpecCode']"
                code="medSpecCode"
                name="供应商家编号"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_medSpecName'"
                v-model="data.head['medSpecName']"
                code="medSpecName"
                name="供应商家名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_medDosageId'"
                v-model="data.head['medDosageId']"
                code="medDosageId"
                name="生产商家ID"
                :default-value="0"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_medDosageCode'"
                v-model="data.head['medDosageCode']"
                code="medDosageCode"
                name="生产商家编号"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_medDosageName'"
                v-model="data.head['medDosageName']"
                code="medDosageName"
                name="生产商家名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_qualitySign'"
                v-model="data.head['qualitySign']"
                code="qualitySign"
                name="品质标识"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.qualitySign)"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_batchCode'"
                v-model="data.head['batchCode']"
                code="batchCode"
                name="批次号"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_number'"
                v-model="data.head['number']"
                code="number"
                name="数量"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_costPrice'"
                v-model="data.head['costPrice']"
                code="costPrice"
                name="成本单价"
                :default-value="0"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_costAmount'"
                v-model="data.head['costAmount']"
                code="costAmount"
                name="成本金额"
                :default-value="0"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_inventorySign'"
                v-model="data.head['inventorySign']"
                code="inventorySign"
                name="在库状态"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.inventorySign)"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询区 -->
        <div class="querybg">
          <el-collapse
            v-if="viewMode == 'list'"
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <el-form
                id="ik-info-head"
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_code'"
                      v-model="searcher['code']"
                      code="code"
                      name="编号"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_qualitySign'"
                      v-model="searcher['qualitySign']"
                      code="qualitySign"
                      name="品质标识"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.qualitySign)"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_batchCode'"
                      v-model="searcher['batchCode']"
                      code="batchCode"
                      name="批次号"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_inventorySign'"
                      v-model="searcher['inventorySign']"
                      code="inventorySign"
                      name="在库状态"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.inventorySign)"
                      :disabled="false"
                    />
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'input_positionCode'"
                      v-model="searcher['positionCode']"
                      code="positionCode"
                      name="药库编码"
                      url="clinic/inventory/inventory/position/find/findPagination"
                      :filed-list="[
                        { code: 'code', name: '编码' },
                        { code: 'name', name: '名称' }
                      ]"
                      search-key="name"
                      :searcher="{'storeCode': storeCode}"
                      default-value=""
                      :disabled="false"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_positionName'"
                      v-model="searcher['positionName']"
                      code="positionName"
                      name="药库名称"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'input_materielCode'"
                      v-model="searcher['materielCode']"
                      code="materielCode"
                      name="药品编号"
                      url="clinic/clinicdic/clinicmedicinedic/clinicmateriel/find/findPagination"
                      :filed-list="[
                        { code: 'materielCode', name: '编码' },
                        { code: 'materielName', name: '名称' },
                      ]"
                      search-key="materielName"
                      :searcher="{storeCode: storeCode, effectiveSign: '1'}"
                      default-value=""
                      :disabled="false"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_materielName'"
                      v-model="searcher['materielName']"
                      code="materielName"
                      name="药品名称"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'input_supplierCode'"
                      v-model="searcher['supplierCode']"
                      code="supplierCode"
                      name="供应商编号"
                      url="clinic/clinicdic/clinicmedicinedic/clinicchaindic/find/findPagination"
                      :filed-list="[
                        { code: 'chainDictionaryCode', name: '编码' },
                        { code: 'chainDictionaryName', name: '名称' },
                      ]"
                      search-key="chainDictionaryName"
                      :searcher="{storeCode: storeCode, effectiveSign: '1', chainDirectoryCode: 'GYS'}"
                      default-value=""
                      :disabled="false"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_supplierName'"
                      v-model="searcher['supplierName']"
                      code="supplierName"
                      name="供应商名称"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'input_manufacturerCode'"
                      v-model="searcher['manufacturerCode']"
                      code="manufacturerCode"
                      name="生产商家编号"
                      url="clinic/clinicdic/clinicmedicinedic/clinicchaindic/find/findPagination"
                      :filed-list="[
                        { code: 'chainDictionaryCode', name: '编码' },
                        { code: 'chainDictionaryName', name: '名称' },
                      ]"
                      search-key="chainDictionaryName"
                      :searcher="{storeCode: storeCode, effectiveSign: '1', chainDirectoryCode: 'SCS'}"
                      default-value=""
                      :disabled="false"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_manufacturerName'"
                      v-model="searcher['manufacturerName']"
                      code="manufacturerName"
                      name="生产商家名称"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 数据表 -->
        <el-table
          v-if="viewMode == 'list'"
          ref="table"
          v-loading="listLoading"
          :data="tableData"
          element-loading-text="加载中..."
          :stripe="true"
          :border="true"
          :fit="true"
          class="ik-list-table"
          height="calc(100% - 50px)"
          :header-row-class-name="'ik-list-table-header-row'"
          :header-cell-class-name="'ik-list-table-header-cell'"
          :row-class-name="'ik-list-table-body-row'"
          :cell-class-name="'ik-list-table-body-cell'"
          :highlight-current-row="true"
          @row-click="rowClick"
        >
          <ik-column-id
            code="id"
            name="ID"
            :edit="false"
          />
          <ik-column-text
            code="code"
            name="编号"
            :edit="false"
          />
          <ik-column-id
            code="positionId"
            name="药库ID"
            :edit="false"
          />
          <ik-column-text
            code="positionCode"
            name="药库编号"
            :edit="false"
          />
          <ik-column-text
            code="positionName"
            name="药库名称"
            :edit="false"
          />
          <ik-column-id
            code="materielId"
            name="药品ID"
            :edit="false"
          />
          <ik-column-text
            code="materielCode"
            name="药品编号"
            :edit="false"
          />
          <ik-column-text
            code="materielName"
            name="药品名称"
            :edit="false"
          />
          <ik-column-number
            code="number"
            name="数量"
            :edit="false"
          />
          <ik-column-number
            v-if="$store.state.user.userRole == 'STORE'"
            code="costPrice"
            name="成本单价"
            :edit="false"
          />
          <ik-column-number
            v-if="$store.state.user.userRole == 'STORE'"
            code="costAmount"
            name="成本金额"
            :edit="false"
          />
          <ik-column-id
            code="supplierId"
            name="供应商家ID"
            :edit="false"
          />
          <ik-column-text
            code="supplierCode"
            name="供应商家编号"
            :edit="false"
          />
          <ik-column-text
            code="supplierName"
            name="供应商家名称"
            :edit="false"
          />
          <ik-column-id
            code="manufacturerId"
            name="生产商家ID"
            :edit="false"
          />
          <ik-column-text
            code="manufacturerCode"
            name="生产商家编号"
            :edit="false"
          />
          <ik-column-text
            code="manufacturerName"
            name="生产商家名称"
            :edit="false"
          />
          <ik-column-text
            code="chandi"
            name="产地"
            :edit="false"
            @onFieldChange="onBodyFieldChange"
          />
          <ik-column-text
            code="proDate"
            name="生产日期"
            :edit="false"
            @onFieldChange="onBodyFieldChange"
          />
          <ik-column-text
            code="expirationNumber"
            name="保质期"
            :edit="false"
            @onFieldChange="onBodyFieldChange"
          />
          <ik-column-select
            code="qualitySign"
            name="品质标识"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.qualitySign)"
            :edit="false"
          />
          <ik-column-text
            code="batchCode"
            name="批次号"
            :edit="false"
          />
          <ik-column-select
            code="inventorySign"
            name="在库状态"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.inventorySign)"
            :edit="false"
          />
        </el-table>
      </el-main>
      <!-- 分页组件 -->
      <el-footer height="40px">
        <ik-pagination
          v-if="viewMode == 'list'"
          ref="ik_list_pagination"
          :page-no="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total-count="pagination.totalCount"
          @pageChangeMethod="pageChange"
        />
        <el-row v-else class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
      <InventoryP ref="InventoryRef" />
    </el-container>
  </el-container>
</template>
<script>
// 表单组件
import IkFormId from '@/components/ik/form/input/IkFormId'
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormNumber from '@/components/ik/form/input/IkFormNumber'
import IkFormSelect from '@/components/ik/form/input/IkFormSelect'
import IkFormDataPopup from '@/components/ik/form/input/IkFormDataPopup'
import IkColumnId from '@/components/ik/table/ikColumn/IkColumnId'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkColumnNumber from '@/components/ik/table/ikColumn/IkColumnNumber'
import IkColumnSelect from '@/components/ik/table/ikColumn/IkColumnSelect'
import IkPagination from '@/components/ik/pagination/IkPagination'
import store from '@/store'
import { getById, findPage, save, update, remove } from '@/api/ik/data/dataApi'
import InventoryP from './InventoryP.vue'
export default {
  components: {
    // 表单组件
    IkFormId,
    IkFormNumber,
    IkFormText,
    IkFormSelect,
    IkFormDataPopup,
    IkColumnId,
    IkColumnText,
    IkColumnNumber,
    IkColumnSelect,
    IkPagination,
    InventoryP
  },
  props: {
  },
  data() {
    return {
      // ===== ===== ===== ===== 权限字段 ===== ===== ===== =====
      storeId: store.getters['user/getStoreId'],
      storeCode: store.getters['user/getStoreCode'],
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'clinic/inventory/inventory/inventory',
      // Web路径
      webPath: 'clinic/inventory/inventory/inventory',
      // 标识字段JSON
      jsonStr: {
        qualitySign: '[{"key": "1", "value": "普通"}, {"key": "2", "value": "精品"}]',
        inventorySign: '[{"key": "0", "value": "不在库"}, {"key": "1", "value": "在库"}]'
      },
      // 界面模式  info - 信息页, list - 列表页
      viewMode: '',
      // 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式, list - 列表模式
      mode: '',
      // 加载标识、列表加载标识
      loading: false,
      listLoading: false,
      // ===== ===== ===== ===== 列表页属性 ===== ===== ===== =====
      // 查询器是否激活
      searcherActive: "0",
      searcher: {},
      // 列表页数据
      tableData: [],
      // 当前选中行
      activeRow: {},
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 2
      },
      // ===== ===== ===== ===== 信息页属性 ===== ===== ===== =====
      // 当前数据id
      id: 0,
      // 当前数据
      data: {
        head: {},
        body: {}
      },
      // 子表清单
      bodyMap: [],
      // 主表验证器
      validate: [],
      // 子表验证器
      bodyValidate: [],
      // 当前子表
      activeTab: '',
      verify: {
        head: {},
        body: {}
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // 获取视图模式
    this.viewMode = this.$route.params.viewMode || "list"
    this.mode = this.$route.params.mode || "list"
    this.id = this.$route.query.id || 0
    // 初始化界面，设置模式取值
    if (this.mode === "list") {
      this.viewMode = "list"
    } else {
      this.viewMode = "info"
    }
    // 列表页进入时的处理
    if (this.viewMode === "list") {
      this.find()
    } else if (this.viewMode === "info") {
      if (this.id !== 0) {
        this.get(this.id)
      }
    }
  },
  methods: {
    // ===== ===== ===== ===== 工具方法 ===== ===== ===== =====
    // 工具方法 - 转为json
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // ===== ===== ===== ===== 工具栏按钮 ===== ===== ===== =====
    listCreateBtn() {
      this.$router.push({ path: '/business/manager/' + this.webPath + '/info/add' })
    },
    // 列表页编辑按钮点击
    listUpdateBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        this.$router.push({ path: '/business/manager/' + this.webPath + '/info/edit', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页详情按钮点击
    listDetailsBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        // 修改为详情模式
        this.$router.push({ path: '/business/manager/' + this.webPath + '/info/details', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页删除按钮点击
    listDeleteBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要删除的行!'
        })
      } else {
        // 问询是否删除
        this.$confirm('删除ID为' + $this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete($this.activeRow.id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 信息页创建按钮点击
    infoCreateBtn() {
      this.$router.push({ path: '/business/manager/' + this.webPath + '/info/add' })
    },
    // 信息页编辑按钮点击
    infoUpdateBtn() {
      // 修改为编辑模式
      this.mode = "edit"
    },
    // 复制按钮点击事件
    infoCopyBtn() {
      // 修改id为控制
      this.data.head.id = 0
      // 修改为编辑模式
      this.mode = "edit"
    },
    infoDetailsBtn() {
      // 修改为编辑模式
      this.mode = "details"
      this.get(this.data.head.id)
    },
    // 保存按钮点击事件
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    // 取消按钮点击事件
    infoCancelBtn() {
      // 修改为详情模式
      this.$router.push({ path: '/business/manager/' + this.webPath + '/list/list' })
    },
    // 查询
    searchBtn() {
      this.find()
    },
    // 重置
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    // ===== ===== ===== ===== 信息页表格行维护 ===== ===== ===== =====
    // 新增行按钮
    addRow(currt, index) {
      this.data.body[currt].splice(index + 1, 0, {})
    },
    // 删除行按钮
    delRow(currt, index) {
      this.data.body[currt].splice(index, 1)
    },
    // ===== ===== ===== ===== 列表页表格点击 ===== ===== ===== =====
    // 行点击事件
    rowClick(row, column, event) {
      this.activeRow = row
    },
    // 字段变更事件
    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    // 子表字段变更事件
    onBodyFieldChange(line, fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.verify.body['item1' + '-' + line + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', line, fieldName, oldValue, newValue)
    },
    // 分页器数据变更
    pageChange(pageNo, pageSize) {
      // 修改分页数据
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      // 刷新数据
      this.find()
    },
    // 开窗点击事件
    searchPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "storeCode") {
        this.searcher["storeCode"] = row.code
      } else if (code === "positionCode") {
        this.searcher["positionCode"] = row.code
      } else if (code === "materielCode") {
        this.searcher["materielCode"] = row.materielCode
      } else if (code === "supplierCode") {
        this.searcher["supplierCode"] = row.chainDictionaryCode
      } else if (code === "manufacturerCode") {
        this.searcher["manufacturerCode"] = row.chainDictionaryCode
      }
    },
    // 开窗点击事件
    headPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "storeCode") {
        this.data.head["storeId"] = row.id
        this.data.head["storeCode"] = row.code
        this.data.head["storeName"] = row.name
      } else if (code === "supplierCode") {
        this.data.head["supplierId"] = row.chainDictionaryId
        this.data.head["supplierCode"] = row.chainDictionaryCode
        this.data.head["supplierName"] = row.chainDictionaryName
      } else if (code === "positionCode") {
        this.data.head["positionId"] = row.id
        this.data.head["positionCode"] = row.code
        this.data.head["positionName"] = row.name
      } else if (code === "inTypeCode") {
        this.data.head["inTypeId"] = row.id
        this.data.head["inTypeCode"] = row.code
        this.data.head["inTypeName"] = row.name
      }
    },
    // ===== ===== ===== ===== 接口通讯方法 ===== ===== ===== =====
    // 保存或修改数据
    saveOrUpdate() {
      const $this = this
      // 验证
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      if ($this.data.head.id) {
        update($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      } else {
        save($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      }
    },
    // 删除数据
    delete(id) {
      const $this = this
      remove($this.bgPath, id).then(response => {
        $this.$message({
          type: 'warning',
          message: '数据已删除!'
        })
        $this.find()
      })
    },
    // 获取数据
    get(id) {
      const $this = this
      // 获取树组件数据
      getById($this.bgPath, id).then(response => {
        $this.data = response.data
      })
    },
    // 查询数据
    find() {
      const $this = this
      $this.listLoading = true
      $this.searcher.storeCode = $this.storeCode
      if (!$this.searcher.inventorySign) {
        $this.searcher.inventorySign = "1"
      }
      // 获取树组件数据
      findPage($this.bgPath, $this.searcher, $this.pagination.pageSize, $this.pagination.pageNo).then(response => {
        // 设置表格数据
        $this.tableData = response.data.list
        // 设置分页器
        $this.pagination.totalCount = response.data.totalCount
        // 设置加载完成
        $this.listLoading = false
      }).catch(() => {
        $this.listLoading = false
      })
    },
    openPrint() {
      this.$refs.InventoryRef.open(this.tableData)
    }
  }
}
</script>
<style lang="scss" >
@import "~@/styles/listinfo.scss";
</style>
